var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.829,25.001c-23.486,0-42.605,19.107-42.605,42.593c0,9.762,7.346,27.986,16.127,46.272 c0.858,0.54,1.447,1.496,1.447,2.6c0,0.11-0.025,0.209-0.037,0.319c9.48,19.438,20.211,38.423,25.068,46.848 c9.664-16.765,42.605-75.374,42.605-96.039C207.434,44.108,188.314,25.001,164.829,25.001z M164.829,90.172 c-12.448,0-22.566-10.13-22.566-22.578c0-12.436,10.118-22.566,22.566-22.566c12.448,0,22.566,10.13,22.566,22.566 C187.394,80.042,177.277,90.172,164.829,90.172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.262,67.594c0,9.075-7.371,16.446-16.434,16.446c-9.063,0-16.434-7.371-16.434-16.446 c0-9.063,7.371-16.434,16.434-16.434C173.892,51.16,181.262,58.531,181.262,67.594z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.602,101.528v78.857c-6.954-5.2-16.029-8.192-25.46-8.192c-6.745,0-13.086,1.484-18.604,4.084 c-5.519,2.6-10.204,6.328-13.613,10.792v-69.439c0-14.521,14.447-26.331,32.217-26.331c4.967,0,9.823,0.944,14.177,2.71 C80.686,95.752,84.561,98.315,87.602,101.528z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.075,119.532v111.467H62.142c-17.77,0-32.217-11.81-32.217-26.331 c0-14.521,14.447-26.343,32.217-26.343c5.188,0,10.228,1.042,14.729,2.931c4.501,1.913,8.462,4.673,11.491,8.131 c0.846,0.969,2.195,1.312,3.385,0.858c1.202-0.454,1.987-1.594,1.987-2.87v-67.844h40.545 c12.436,25.595,26.858,49.976,27.913,51.754c0.552,0.932,1.558,1.509,2.637,1.509c1.079,0,2.085-0.576,2.637-1.509 c1.055-1.778,15.477-26.159,27.913-51.754H226.075z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f33b16ae6d9706b5da97df56074cf02c.svg";
export { ForwardRef as ReactComponent };